__webpack_require__.p = "https://btc.dev5.glprotocol.com/";